"use strict";

/**
 * @generated SignedSource<<2060b75b3a23b8ad59079220c3e4f608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSupplierMetaSupplier_Supplier",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dbId",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }],
  "type": "Supplier",
  "abstractKey": null
};
node.hash = "fc5b81fad31aed7c63e4339c211c0af4";
export default node;